// extracted by mini-css-extract-plugin
export var backdropBlur = "_l0-0";
export var contentCard = "_l0-5";
export var frame = "_l0-2";
export var image = "_l0-4";
export var imagePane = "_l0-3";
export var modal = "_l0-1";